/* -----------------Globals--------------- */

import { pageViewTypes } from "@constants/tracking";
/* -----------------Child components--------------- */
import StudyPackContainer from "@features/dashboard/screens/StudyPackContainer";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { getShowStudyPackViews } from "@helpers/exams";
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";
import { Redirect } from "expo-router";

const StudyPackRoute = () => {
	useAnalytics({
		type: pageViewTypes.studyPack,
	});

	const {
		currentExamContext: { studyPackCollectionId },
	} = useExamContext();

	const showStudyPackViews = studyPackCollectionId
		? getShowStudyPackViews(studyPackCollectionId)
		: true;
	if (isWeb && !showStudyPackViews) {
		return <Redirect href={"/practice-tests"} />;
	}
	return (
		<>
			<DocumentTitle title="Study-Pack" />
			<StudyPackContainer />
		</>
	);
};

export default StudyPackRoute;
